import React from 'react'
import { sessionSelectors } from './redux'
import { connect } from 'react-redux'
import { compose } from 'recompose'

const isUserAllowed = (allowedRoles, userRole) => {
    if (!userRole) return false;
    return allowedRoles.includes(userRole);
}

const Secured = ({children, loggedInUser, role, allowedRoles}) => {
    let allowed = false;
    if (loggedInUser && role) {
        allowed = isUserAllowed(allowedRoles, role);
    }
    return (
        <span>
            {allowed && children}
        </span>
    )
}

const mapStateToProps = (state) => ({
    loggedInUser: sessionSelectors.loggedInUser(state),
    role: sessionSelectors.role(state),
});

const mapDispatchToProps = (dispatch) => ({
});

export default compose (
    connect(mapStateToProps, mapDispatchToProps),
)(Secured)